import { sleep_injector } from './sleep';
const $inject = {
  Promise
};
export default sleep_injector($inject)